// Import Dependencies
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import { SALES_PHONE_NUMBER_FORMATTED } from '~/common/utils/consts';

import HeaderGroup from '~/common/components/HeaderGroup';

// Import Stylesheet
import styles from './pending.css';

@inject('pendingStore')
@observer
export default class Pending extends Component {
    componentDidMount() {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }

    render() {
        const { referenceNumber, selectedNumber } = this.props.pendingStore;

        return (
            <div className={styles.wrapper} id="pending">
                <HeaderGroup>
                    <h1>
                        Uh Oh!
                    </h1>
                    <h2>
                        Looks like there was an issue with your order.
                    </h2>
                </HeaderGroup>
                <p className={styles.text}>
                    Don’t stress, we’ll get this straightened out for you! Just give our 24/7 support team a call at <strong className={styles.strong}>{SALES_PHONE_NUMBER_FORMATTED}</strong>. It helps to have this information handy when you call:
                </p>
                <ol className={styles.list}>
                    <li>
                        Reference Number: <strong className={styles.strong} id="pending__ref-number">{referenceNumber}</strong>
                    </li>
                    <li>
                        Your Number: <strong className={styles.strong} id="pending__number">{selectedNumber}</strong>
                    </li>
                </ol>
            </div>
        );
    }
}
